"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JiraClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
const isParamsWithJiraConnection = (obj) => {
    return ['jiraToken', 'jiraLogin', 'jiraUrl'].every((key) => key in obj);
};
class JiraClient extends authenticated_client_1.AuthenticatedClient {
    getConfiguration(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`${this.baseUrlForJiraByCsProjectId(params)}/configurations`);
            return response.payload;
        });
    }
    getProjects(getProjectsParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield (isParamsWithJiraConnection(getProjectsParams)
                ? this.httpPost(`${this.baseUrlForJiraConnection()}/projects`, getProjectsParams)
                : this.httpGet(`${this.baseUrlForJiraByCsProjectId(getProjectsParams)}/projects`));
            return response.payload;
        });
    }
    getProject(getProjectParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { jiraProjectId } = getProjectParams;
            const response = yield this.httpGet(`${this.baseUrlForJiraByCsProjectId(getProjectParams)}/jira-projects/${jiraProjectId}`);
            return response.payload;
        });
    }
    getIssueTypes(getIssueTypesParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { jiraProjectId } = getIssueTypesParams;
            const response = yield (isParamsWithJiraConnection(getIssueTypesParams)
                ? this.httpPost(`${this.baseUrlForJiraConnection()}/project-issue-types`, getIssueTypesParams)
                : this.httpGet(`${this.baseUrlForJiraByCsProjectId(getIssueTypesParams)}/jira-projects/${jiraProjectId}/issue-types`));
            return response.payload;
        });
    }
    getIssueType(getIssueTypeParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { jiraProjectId, jiraIssueTypeId } = getIssueTypeParams;
            const response = yield this.httpGet(`${this.baseUrlForJiraByCsProjectId(getIssueTypeParams)}/jira-projects/${jiraProjectId}/issue-types/${jiraIssueTypeId}`);
            return response.payload;
        });
    }
    getProjectIssueTypeFields(getProjectIssueTypeFieldsParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { jiraProjectId, jiraIssueTypeId } = getProjectIssueTypeFieldsParams;
            const response = yield this.httpGet(`${this.baseUrlForJiraByCsProjectId(getProjectIssueTypeFieldsParams)}/jira-projects/${jiraProjectId}/issue-types/${jiraIssueTypeId}/fields`);
            return response.payload;
        });
    }
    createIssue(createIssueParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { jiraIssueTypeId, jiraProjectId, entityType, entityId } = createIssueParams;
            const baseUrl = `${this.baseUrlForJiraByCsProjectId(createIssueParams)}/jira-projects/${jiraProjectId}/issue-types`;
            const url = `${baseUrl}/${jiraIssueTypeId}/${entityType}/${entityId}/issues`;
            const response = yield this.httpPost(url, { fields: createIssueParams.fields });
            return response.payload;
        });
    }
    searchIssues(searchIssuesParams, displayCreatorUsername) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { entityType, entityId } = searchIssuesParams;
            const issuesParam = (_a = entityId === null || entityId === void 0 ? void 0 : entityId.map((entityId) => `entityId=${entityId}`).join('&')) !== null && _a !== void 0 ? _a : '';
            const params = [entityType ? `entityType=${entityType}` : null, issuesParam.length ? issuesParam : null]
                .filter((v) => v !== null)
                .join('&');
            const displayName = Boolean(displayCreatorUsername);
            const response = yield this.httpGet(`${this.baseUrlForJiraByCsProjectId(searchIssuesParams)}/issues?${params}&displayCreatorUsername=${displayName}`);
            return response.payload;
        });
    }
    deleteCsErrorJiraIssue(deleteCsErrorParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { csErrorJiraIssueId } = deleteCsErrorParams;
            const response = yield this.httpDelete(`${this.baseUrlForJiraByCsProjectId(deleteCsErrorParams)}/issues/${csErrorJiraIssueId}`);
            return response.payload;
        });
    }
    getFieldJqlSuggestion(getFieldSqlSuggestionParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, fieldName, query } = getFieldSqlSuggestionParams;
            const response = yield this.httpGet(`${this.baseUrlForJiraByCsProjectId({
                projectId,
            })}/jql/field-suggestions/${encodeURIComponent(fieldName)}?query=${encodeURIComponent(query !== null && query !== void 0 ? query : '')}`);
            return response.payload;
        });
    }
    getIssuePickerSuggestions(getFieldLinkedIssueSuggestionsParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, jiraProjectId, query } = getFieldLinkedIssueSuggestionsParams;
            const response = yield this.httpGet(`${this.baseUrlForJiraByCsProjectId({
                projectId,
            })}/issue-picker?jiraProjectId=${jiraProjectId}&query=${encodeURIComponent(query !== null && query !== void 0 ? query : '')}`);
            return response.payload;
        });
    }
    getUsersAssignableToIssues(getAssignableUsersToIssuesParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, jiraProjectId, query } = getAssignableUsersToIssuesParams;
            const response = yield this.httpGet(`${this.baseUrlForJiraByCsProjectId({
                projectId,
            })}/jira-projects/${jiraProjectId}/assignable-users?query=${encodeURIComponent(query !== null && query !== void 0 ? query : '')}`);
            return response.payload;
        });
    }
    baseUrlForJiraConnection() {
        return '/v1/jira';
    }
    baseUrlForJiraByCsProjectId(params) {
        return `/v1/projects/${params.projectId}/jira`;
    }
}
exports.JiraClient = JiraClient;
//# sourceMappingURL=jira.client.js.map